import React from 'react';
import HomeownerImport from './HomeownerImport';
import VendorImport from './VendorImport';
import { DEFAULT_VENDOR_CATEGORIES } from '../shared/vendorCategories';

const SAMPLE = [
  'business_name,category,contact_name,phone,email,website,service_area,notes,discount,discount_code',
  'Pro Nice & Clean LLC,Interior Cleaning,,(407) 969-2177,,,"Volusia County, FL, Seminole County, FL",,,',
  'Tom\'s Touch Landscaping,Landscaping,,(386) 675-3834,,,"Volusia County, FL; Seminole County, FL",,,',
  'Blanchard Insurance,Insurance,,(321) 231-2126,,,Florida,,,',
  'NextMortgage,Mortgage & Lending,,(407) 617-1874,,,"Seminole County, FL",,,',
  'Wray\'s Dryer Vent Cleaning,Dryer Vent Cleaning,,(386) 555-0144,,,"Orange County, FL",,,',
].join('\n');

/**
 * Local screenshot page for the import dialogs. Production builds leave this out.
 */
export default function ImportPreview() {
  const params = new URLSearchParams(window.location.search);
  const profile = { id: 'preview-agent', first_name: 'Alex', last_name: 'Rivera', team_id: 'team-1' };
  if (params.get('flow') === 'clients') {
    return <HomeownerImport profile={profile} onClose={() => {}} onFinished={() => {}} />;
  }
  return (
    <VendorImport
      profile={profile}
      categories={DEFAULT_VENDOR_CATEGORIES.map((name) => ({ id: name, name }))}
      existingVendors={[{ id: 'harbor', name: 'Harbor Plumbing' }]}
      initialCsv={params.get('sample') === 'preview' ? SAMPLE : ''}
      onClose={() => {}}
      onFinished={() => {}}
    />
  );
}
